import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UserInfo, UserService } from '../../../services/user.service';
import { AutoOpenMenuComponent } from '../auto-open-menu/auto-open-menu.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    imports: [
        MatIconModule,
        AutoOpenMenuComponent,
        MatButtonModule,
        RouterModule,
        MatMenuModule
    ]
})
export class NavMenuComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly matDialog = inject(MatDialog);
    protected readonly userSvc = inject(UserService);
    user: UserInfo;

    ngOnInit() {
        this.userSvc.UserSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
            this.user = user;
        });
    }


}
